import Echo, { type Broadcaster } from 'laravel-echo'
import Pusher from 'pusher-js'

import { useAuthStore } from '@stores/auth'

export const useEcho = (): Echo<keyof Broadcaster> => {
  const config = useRuntimeConfig()

  // @ts-expect-error window.Pusher
  window.Pusher = Pusher
  // @ts-expect-error window.Pusher
  window.Pusher.logToConsole = false

  const auth = useAuthStore()
  auth._hydrateFromStorage()

  const authEndpoint = `${config.public.appUrl}/broadcasting/auth`

  const accessToken = auth.accessToken
  const tokenType = auth.tokenType

  const pusherPort = Number(config.public.pusherPort)
  const pusherHost = config.public.pusherHost

  return new Echo({
    broadcaster: 'pusher',
    key: config.public.pusherKey,
    authEndpoint,
    wsHost: pusherHost,
    wsPort: pusherPort,
    wssHost: pusherHost,
    wssPort: pusherPort,
    forceTLS: config.public.pusherTls,
    cluster: 'mt1', // Backward compatibility
    enabledTransports: ['ws', 'wss'],
    auth: {
      headers: accessToken
        ? { Authorization: `${tokenType} ${accessToken}` }
        : {},
    },
  })
}
